
export default {
  name: 'SectionSize',

  data: function () {
    return {
      bodyType: 'size', // size | spark
      isOpen: true,
    };
  },

  props: {
    filters: {
      type: Array,
      default: () => [],
    },
    filtersSelected: {
      type: Object,
      default: () => {},
    },
    filterTiporazmer: {
      type: Object,
      default: () => {},
    },
    sparkSlug: {
      type: [String, Boolean],
      default: '',
    },
    isUpdateLocalFilter: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['onChangeFilterVariant'],

  computed: {
    selectedSpart1: function () {
      const sparkSlug = Object.keys(this.filtersSelected[this.sparkSlug] || {})[0];
      if (!sparkSlug) {
        return {};
      }

      return {
        [this.sparkSlug]: {
          [sparkSlug]: sparkSlug,
        },
      };
    },
    selectedSpart2: function () {
      const sparkSlug = Object.keys(this.filtersSelected[this.sparkSlug] || {})[1];
      if (!sparkSlug) {
        return {};
      }

      return {
        [this.sparkSlug]: {
          [sparkSlug]: sparkSlug,
        },
      };
    },
  },

  components: {
    SelectSizeFilter: () => import('./_SelectSizeFilter'),
  },

  mounted: function () {
    if (this.sparkSlug && this.filtersSelected?.[this.sparkSlug]) {
      this.bodyType = 'spark';
    }
  },

  methods: {
    changeOpen: function () {
      if (this.sparkSlug) {
        return;
      }
      this.isOpen = !this.isOpen;
    },
    changeBodyType: async function (val) {
      const filtersSelected = { ...this.filtersSelected };
      this.filters.map((filter) => {
        delete filtersSelected[filter.slug];
      });
      delete filtersSelected[this.sparkSlug];
      this.bodyType = val;
      this.$emit('getUpdateFilters', filtersSelected);
    },

    changeTiporazmer: function (slug1, slug2, index) {
      const sparkSlug = Object.keys(this.filtersSelected[this.sparkSlug] || {})[index];

      const filtersSelected = { ...this.filtersSelected };
      if (sparkSlug) {
        delete filtersSelected[this.sparkSlug][sparkSlug];
      }
      filtersSelected[this.sparkSlug] = {
        ...(filtersSelected[this.sparkSlug] || {}),
        [slug2]: slug2,
      };

      this.$emit('getUpdateFilters', filtersSelected);
    },
  },
};
